// extracted by mini-css-extract-plugin
export default {"skill":"Skills_skill__5ILrh","skillDiv":"Skills_skillDiv__EBIIJ","skill_in_div":"Skills_skill_in_div__ojodH","logo":"Skills_logo__vAZoX","skillH3":"Skills_skillH3__EownS"};